/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Scalar } from './Scalar';
import {
    instanceOfScalar,
    ScalarFromJSON,
    ScalarFromJSONTyped,
    ScalarToJSON,
} from './Scalar';

/**
 * @type AnalysisResultDtoBeamQualityFactor
 * 
 * @export
 */
export type AnalysisResultDtoBeamQualityFactor = Scalar;


export function AnalysisResultDtoBeamQualityFactorFromJSON(json: any): AnalysisResultDtoBeamQualityFactor {
    return AnalysisResultDtoBeamQualityFactorFromJSONTyped(json, false);
}

export function AnalysisResultDtoBeamQualityFactorFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnalysisResultDtoBeamQualityFactor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...ScalarFromJSONTyped(json, true) };
    return  ScalarFromJSONTyped(json, true);
}

export function AnalysisResultDtoBeamQualityFactorToJSON(value?: AnalysisResultDtoBeamQualityFactor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfScalar(value)) {
        return ScalarToJSON(value as Scalar);
    }

    return {};
}

/**
 * Check if a given object implements the AnalysisResultDtoBeamQualityFactor interface.
 */
export function instanceOfAnalysisResultDtoBeamQualityFactor(value: any): value is AnalysisResultDtoBeamQualityFactor {
    if (instanceOfScalar(value)) return true;
    return false;
}

